var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBubble = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.5.25a4.25 4.25 0 1 0 0 8.5 4.25 4.25 0 0 0 0-8.5zm-8.5 6a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5zm6 5a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBubble);
export default ForwardRef;